import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { GuiOptions } from "./types";

/**
 * Initial state.
 */
const initialState: GuiOptions = {
  selectedQuoteIds: [],
  selectedUserIds: []
};

/**
 * Gui Options slice.
 */
const guiOptionsSlice = createSlice({
  name: "guiOptions",
  initialState: initialState,
  reducers: {
    resetGuiOptions(state) {
      state = initialState;

      return state;
    },
    updateSelectedQuoteIds(state, action: PayloadAction<number[]>) {
      state.selectedQuoteIds = action.payload;

      return state;
    },
    updateSelectedUserIds(state, action: PayloadAction<string[]>) {
      state.selectedUserIds = action.payload;
      
      return state;
    }
  },
});

export const { updateSelectedQuoteIds, updateSelectedUserIds } = guiOptionsSlice.actions;

export default guiOptionsSlice.reducer;
